<template>
  <div>
    <spinner v-if="!image"></spinner>
    <div v-else>
      <h1 class="align-center">Edit {{ image.title }}</h1>

      <edit-form :save="update" :image="image"></edit-form>
    </div>
  </div>
</template>

<script>
import imageApi from './../../../../api/image';
import EditForm from './Form';

export default {
  components: {
    'edit-form': EditForm,
  },
  props: {
    id: {
      required: true,
    }
  },
  data() {
    return {
      image: null,
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      imageApi.fetch(this.id, ['book', 'artSubjects', 'image', 'styles']).then((image) => {
        this.image = image;
      });
    },
    update(form) {
      imageApi.update(form, form.id).then((image) => {
        toastr.success('Edited successfully');

        setTimeout(() => {
          location.href = '/profile/portfolio';
        }, 2000);
      });
    },
  },
};
</script>